import { useEffect, useState } from "react";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { getWishlist } from "./Wishlist.service";
import { deleteWhishlist, getUser } from "../Auth/auth.service";
import CustomizedWishlistTables from "../../common/WishListTable";
import CustomizedTables from "../../common/Table";

const Wishlist = () => {
  const [user, setUser] = useState<any>(null);
  const [editItem, setEditItem] = useState<any>(null);
  const [perModal, setPermModal] = useState<any>(null);

  const columns = [
    { key: "name", label: "Name", minWidth: 150 },
    { key: "email", label: "Email", minWidth: 130 },
    { key: "number", label: "Mobile Number", minWidth: 150 },
    { key: "wishlist", label: "Wish List", minWidth: 200 },
  ];

  useEffect(() => {
    loadData();
  }, []);
const loadData=()=>{
  getUser()
    .then((usersData: any) => {
      const usersWithWishlist = usersData.filter(
        (user: any) => user?.wishlist && user?.wishlist.length > 0
      );

      const fetchUserWithWishlist = async (user: any) => {
        try {
          const wishlistData: any = await getWishlist(user._id);
          let wishlist: any[] = wishlistData?.wishlist || [];

          const wishlistProperties =
            Array.isArray(wishlist) && wishlist.length > 0
              ? wishlist.map((property: any) => property.name).join(", ")
              : "No wishlist";

          return { ...user, wishlistProperties };
        } catch (err) {
          return { ...user, wishlistProperties: "Error fetching wishlist" };
        }
      };

      Promise.all(usersWithWishlist.map(fetchUserWithWishlist))
        .then((usersWithProperties) => {
          setUser(usersWithProperties);
        })
        .catch((err) => {
          console.error("Error processing users:", err);
        });
    })
    .catch((err) => {
      console.error("Error fetching users:", err);
    });
}
  const data = user?.map((user: any) => ({
    name: user.name,
    email: user.email,
    number: user.number,
    wishlist: user.wishlistProperties,
  }));
  const deleteItemPermenant =()=>{
    deleteWhishlist(editItem._id)
      .then((res: any) => {
        setPermModal(false);
        // showSuccessToast(res.message);
        loadData();
      })
      .catch((err: any) => {
        // showErrorToast(err.message);
      });
  }
  return (
    <Box sx={{ paddingY: 6, width: "100%" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h2>User Wishlist</h2>
      </Box>
      <CustomizedWishlistTables columns={columns} data={data} isUser={false} setEditItem={setEditItem} setPermModal={setPermModal}/>
      <Dialog
        sx={{ "& .MuiDialog-paper": { width: "80%", maxHeight: 435 } }}
        maxWidth="xs"
        open={perModal}
      >
        <DialogTitle>Delete Confirmation</DialogTitle>
        <DialogContent dividers>
          <Typography>
            Are you sure want to delete this item permanently, once deleted
            cannot be reversed?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button color="secondary" onClick={() => setPermModal(false)}>
            {" "}
            Cancel
          </Button>
          <Button color="error" value="Delete" onClick={deleteItemPermenant}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Wishlist;
